import lazyImport from '../../../Utils/Loading/loadingHelpers'

export const ToggleButton = lazyImport(() => import('@mui/material/ToggleButton'))
export const ToggleButtonGroup = lazyImport(() => import('@mui/material/ToggleButtonGroup'))